import React, { useState } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";

function AddSubForm() {

  const [value, setValue] = useState("")


  const options = [
    { label: 'Select', value: 'Select' },
    { label: 'box basbousa Large (006)', value: 'box basbousa Large (006)' },
    { label: 'box basbousa Small (006)', value: 'box basbousa Small (006)' },
    { label: 'Bx Basbousah S (008)', value: 'Bx Basbousah S (008)' },
    { label: 'Masala', value: 'Masala' },
    { label: 'Pespsi 330ml (010)', value: 'Pespsi 330ml (010)' },
    { label: 'potatoes (007)', value: 'potatoes (007)' },

  ]

  const navigate = useNavigate();
  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-[#7B20C7] text-2xl">Add Subscriptions</h1>
          </div>
        </div>
        <div className="w-full">
          <form
            action=""
            className="w-full"
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full">
              <label htmlFor="" className="w-full lg:w-1/3">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Package Name
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder=""
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full lg:w-1/3">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Package Amount
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder=""
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full lg:w-1/3">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Expire Days
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Expire Days"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>
            {/* **************************************RADIO BUTTON SELRCT */}
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full pt-3">
              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Category
                </span>
                <div className="mb-2 pt-0">

                  <Select type='text'
                    className="placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder="Select"
                    options={options}
                    defaultValue={value}
                    onChange={setValue}
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Discount(%)
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="0"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                Service/Delivery Charge
                </span>
                <div className="mb-2 pt-0">
                  <input

                    type="radio"
                    name="Charge"
                    id="Charge"
                    value="Charge"
                    checked
                  />
                  <label className="form-check-label ps-2 pe-3 text-[#7B20C7] text-sm mb-2 " for="Charge">
                    Yes
                  </label>
                </div>
              </label>

              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Delivery Amount
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="100"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>

            {/* **********************************************TABLE */}

            <div className="flex lg:flex-row gap-8 w-full pt-3 pb-3 ">

              <labele htmlFor="" className="w-full lg:w-1/4">
                <h1 className="font-semibold mb-4 text-sm text-[#7B20C7]">Category</h1>
                <input type='text'
                  className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white  rounded  text-xs shadow outline-none focus:outline-none focus:shadow-outline w-full"

                  placeholder="Masala"

                />
              </labele>

              <labele htmlFor="" className="w-full lg:w-1/4">
                <h1 className="font-semibold mb-4 text-sm text-[#7B20C7]">Meal Qty</h1>
                <input
                  type="text"
                  placeholder="1"
                  className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white  rounded  text-xs shadow outline-none focus:outline-none focus:shadow-outline w-full"
                />

              </labele>




              <label>
                <h1 className="font-semibold mb-2 text-sm text-[#7B20C7]">Delete</h1>
                <div className="flex  justify-center ">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" height={20} width={20} className=" border rounded-2xl		border-[#7B20C7] fill-[#7B20C7] cursor-pointer p-1"><path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z" /></svg>
                </div>
              </label>
            </div>


            {/* **********************************************END-TABLE */}


            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full pt-3">
              <label htmlFor="" className="w-full lg:w-3/6">
                <span className=" text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Details
                </span>
                <div className="mb-2 pt-0">
                  <textarea rows={3}
                    type="text"
                    placeholder="Details"
                    className="px-2 py-5 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Company Subscriptions
                </span>
                <div className="mb-2 pt-0">
                  <input

                    type="radio"
                    name="exampleRadios"
                    id="exampleRadios1"
                    value="option1"
                    checked
                  />
                  <label className="form-check-label ps-2 pe-3 text-[#7B20C7] text-sm mb-2 " for="exampleRadios1">
                    Yes
                  </label>
                  <input
                    className="ps-5"

                    type="radio"
                    name="exampleRadios"
                    id="exampleRadios2"
                    value="option2"
                  />
                  <label className="form-check-label  ps-2 pe-3 text-[#7B20C7] text-sm mb-2 " for="exampleRadios2">
                    No
                  </label>
                </div>
                <div className="w-full">
                  <span className="text-[#7B20C7] text-xs mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                    Package Amount Discount
                  </span>
                  <div className="mb-2 pt-0">
                    <input
                      type="text"
                      placeholder=" "
                      className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    />
                  </div>
                </div>
              </label>


              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Meal Type
                </span>
                <div className="mb-2 pt-0">
                  <input

                    type="radio"
                    name="Meal"
                    id="Meal"
                    value="Meal"
                    checked
                  />
                  <label className="form-check-label ps-2 pe-3 text-[#7B20C7] text-sm mb-2 " for="Meal">
                    Yes
                  </label>

                </div>
              </label>

              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Total meal quantity
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder=" "
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>


            <span className="w-full bg-[#7B20C7] h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="submit"
              >
                Submit
              </button>
              <button
                className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default AddSubForm;
